import { IdcardOutlined } from '@ant-design/icons';
import {
  IWidgetType,
  WidgetCategory,
  WidgetMainType,
  tran,
} from '@framework/engine';
import React from 'react';
import { ISiapDataWidget, WidgetSiapDataType } from './ISiapDataWidget';
import { SiapDataConfigComponent } from './SiapDataConfigComponent';
import { SiapDataConfigSchema } from './SiapDataConfigSchema';
import { SiapDataPreviewComponent } from './SiapDataPreviewComponent';
import { SiapDataWidgetComponent } from './SiapDataWidgetComponent';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    SiapData = 'siapData',
  }
}

export const SiapDataWidgetType: IWidgetType<ISiapDataWidget> = {
  type: WidgetSiapDataType,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Informazioni SIAP',
  icon: <IdcardOutlined />,
  hasValue: false,

  formComponent: SiapDataWidgetComponent,

  configComponent: SiapDataConfigComponent,
  configValidator: SiapDataConfigSchema,

  previewComponent: SiapDataPreviewComponent,

  translationSchema: tran.widget({}),
  rules: [],
};
